module.exports = __webpack_public_path__ + "static/media/whitePlus.7308dcfe.svg";